/**
 * Copyright © 2026 Adnuntius AS.
 */
import {firstValueFrom} from 'rxjs';
import {Component, Inject, OnInit, signal} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './library-creative-copy-modal.component.html';
import {nextCopyTitle} from '../../components/util/next-copy-title';
import {Uuid} from '../../components/util/uuid';
import {LibraryCreativeApiService} from './library-creative-api.service';
import {AdnModalLoadingService} from '../common/util/adn-modal-loading.service';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

export interface LibraryCreativeCopyModalResult {
  destination: boolean;
  creativeId: string;
}

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-library-creative-copy-modal',
  template
})
export class LibraryCreativeCopyModalComponent implements OnInit {
  model: any;
  onComplete: (result: LibraryCreativeCopyModalResult) => void;

  sourceName = '';
  name = '';
  destination = true;
  readonly disabled = signal(false);
  readonly validationErrors = signal<any[]>([]);

  private creative: any;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(LibraryCreativeApiService) private readonly LibraryCreative: LibraryCreativeApiService,
    @Inject(AdnModalLoadingService) private readonly adnModalLoading: any
  ) {
  }

  ngOnInit(): void {
    this.creative = _.cloneDeep(this.model);
    this.sourceName = this.model?.name || '';
    this.name = nextCopyTitle(this.sourceName);
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  copyCreative(): void {
    if (this.disabled()) {
      return;
    }
    this.disabled.set(true);
    this.validationErrors.set([]);
    this.adnModalLoading.applyModalLoading();

    const payload = {
      ...this.creative,
      name: this.name
    };
    const newId = Uuid.generate();

    firstValueFrom(this.LibraryCreative.copyCreative(payload, {lineItemId: payload.lineItem?.id || payload.lineItem, creativeId: newId, userState: payload.userState})).then(() => {
      this.adnModalLoading.removeModalLoading();
      this.onComplete?.({destination: this.destination, creativeId: newId});
      this.bsModalRef.hide();
    }, (errors: any) => {
      this.disabled.set(false);
      this.validationErrors.set(_.get(errors, ['data', 'errors'], []));
      this.adnModalLoading.removeModalLoading();
    });
  }
}
